import React, { memo } from "react";
import cx from "clsx";
import { motion, MotionValue } from "framer-motion";
import Image from "next/image";
import { BLURED_NIGHT_SKY_MOBILE } from "@/constants";

type PanelBackgroundProps = {
  stationaryContentY: MotionValue<number>;
  backgroundOverlayOpacity: MotionValue<number>;
  borderRadius: MotionValue<string>;
  panelBoxShadow: MotionValue<string>;
};

const PanelBackground = ({
  stationaryContentY,
  backgroundOverlayOpacity,
  borderRadius,
  panelBoxShadow,
}: PanelBackgroundProps) => {
  return (
    <>
      <motion.div
        style={{ y: stationaryContentY }}
        className="absolute inset-0 h-screen will-change-[transform] before:pointer-events-none before:absolute before:inset-0 before:z-1 before:h-full before:w-full before:bg-gradient-to-b before:from-[#2E335A] before:from-50% before:to-[#9452D1]/20 before:blur-xl"
      >
        <Image
          className="absolute bottom-0 h-screen w-screen object-cover"
          src="/background/bg-night-sky.mobile.webp"
          alt="main background"
          fill
          priority
          sizes="100vw"
          fetchPriority="high"
          placeholder="blur"
          blurDataURL={BLURED_NIGHT_SKY_MOBILE}
        />
        <Image
          src="/shared/house.mobile.webp"
          alt=""
          aria-hidden
          fill
          priority
          sizes="(max-width: 480px) 100vw, 480px"
          fetchPriority="high"
          className="!fixed !inset-y-16 z-1"
        />
      </motion.div>
      <motion.div
        className={cx(
          "bg-violet/5 absolute inset-0 z-10 h-full w-full touch-none backdrop-blur-2xl",
        )}
        style={{
          borderRadius,
        }}
      />
      <motion.div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-10 h-full w-full"
        style={{
          borderRadius,
          boxShadow: panelBoxShadow,
        }}
      />
      <motion.div
        style={{ opacity: backgroundOverlayOpacity }}
        className="from-deep-indigo to-charcoal-indigo absolute inset-0 h-full w-screen bg-linear-145 will-change-[opacity] contain-paint"
      />
      <motion.div
        className="bg-soft-purple/10 absolute inset-0 z-1 h-full w-full blur-3xl will-change-[opacity]"
        style={{ opacity: backgroundOverlayOpacity }}
      />
    </>
  );
};

export default memo(PanelBackground);
